import { render, staticRenderFns } from "./403.vue?vue&type=template&id=246dc5be&scoped=true"
import script from "./403.vue?vue&type=script&lang=js"
export * from "./403.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "246dc5be",
  null
  
)

export default component.exports